module.exports = __webpack_public_path__ + "img/maylor22.bf55ebcc.png";